<template>
	<section v-if="items.length" class="content-section contentblocks">
		<slot name="blocks-header" />
		<content-block
			v-for="item in items"
			:key="item.ID"
			:image="item.image"
			:image-webp="item.imageWebp ?? ''"
			:image-alt="item.imageAlt ?? ''"
			:header="item.header"
			:content="item.content"
			class="row contentblock"
		/>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--cta-color);
}
</style>
